import { AuthConfig } from "angular-oauth2-oidc";

export const authCodeFlowConfig: AuthConfig = {
  issuer: "https://sso.io-market.com/application/o/demo/",
  redirectUri: "https://accounts.io-market.net/#/auth/sso-callback?",
  clientId: "d4ewoGN3uIvC1T3HQaBdHGZqb7WQ8Qw9VaZ6fftZ",
  responseType: "id_token token",
  scope: "email profile openid",
  showDebugInformation: true,
  strictDiscoveryDocumentValidation: false,
};
